import { scoreHex, scoreTextClass } from "../../utils/helpers/scoreColors";

// The tinted percentage pill shared by the teacher grid and the school matrix —
// one definition of the tier color, the `22` alpha wash behind it and the slate
// em-dash that stands in for a school or teacher with no counted score yet.
export default function ScoreBadge({ value }) {
  if (value == null) {
    return <span className="text-[10px] font-medium text-slate-500">—</span>;
  }
  return (
    <span
      className={`text-[10px] font-black px-1.5 py-0.5 rounded ${scoreTextClass(value)}`}
      style={{ backgroundColor: `${scoreHex(value)}22` }}
    >
      {Math.round(value)}%
    </span>
  );
}
